import ChevronRight from '../../design_system/icon/ChevronRight';
import TextLink from '../../design_system/Link/TextLink';
import {ContentColor} from '../../design_system/theme/useContentPalette';
import Flex from '../flex/Flex';

import React from 'react';

export interface Breadcrumb {
  readonly name: string;
  readonly url: string;
}

export interface Props {
  readonly breadcrumbs: Breadcrumb[];
}

export default function BreadcrumbNav(props: Props): JSX.Element {
  const {breadcrumbs} = props;
  const elements = breadcrumbs.map((item, i) => {
    let chevron = null;
    if (i > 0) {
      chevron = (
        <ChevronRight
          color={ContentColor.AUXILIARY1}
          size={20}
        />
      );
    }
    const isParent = i < breadcrumbs.length - 1;
    return (
      <React.Fragment key={i}>
        {chevron}
        <TextLink
          textProps={{
            color: isParent
              ? ContentColor.PRIMARY_SUBDUED
              : ContentColor.PRIMARY,
          }}
          to={item.url}
        >
          {item.name}
        </TextLink>
      </React.Fragment>
    );
  });
  return <Flex>{elements}</Flex>;
}
